export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <path
                d="M10.9386 16.9849L32.4236 8.25215C33.4978 7.81552 34.7218 8.34003 35.1466 9.41902L38.125 16.9849M18.4364 25.9235H24.0636M18.4364 31.6386H31.5636M43.75 22.7V19.0682C43.75 17.9176 42.8173 16.9849 41.6667 16.9849H8.33333C7.18274 16.9849 6.25 17.9176 6.25 19.0682V22.7C9.06143 22.7 11.875 24.6043 11.875 28.4151C11.875 32.2259 9.06357 34.1302 6.25 34.1302V37.762C6.25 38.9126 7.18274 39.8453 8.33333 39.8453H41.6667C42.8173 39.8453 43.75 38.9126 43.75 37.762V34.1302C40.9386 34.1302 38.125 31.2716 38.125 27.938C38.125 24.6043 40.9386 22.7 43.75 22.7Z"
                stroke="#949494"
                strokeWidth="3.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
